// extracted by mini-css-extract-plugin
module.exports = {"popup":"HeaderCell_popup__2RYls","fadeIn":"HeaderCell_fadeIn__1BNha","fadeOut":"HeaderCell_fadeOut__1t7-c"};